import { Box, Button } from "@mui/material"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectFlip } from "swiper/modules"

import QrCodeIcon from '@mui/icons-material/QrCode';

import EIDComponent from "./eID.component"
import ShareEIDDialogComponent from "../dialogs/shareEID-dialog.component";
import { useState } from "react";

const EIDDetailsComponent = ({details, eIDQRCode}) => {
    const [openShareIDDialog, setOpenShareIDDialog] = useState(false)
    
    const handleOpenShareEIDDialog = () => {
        setOpenShareIDDialog(true)
    }

    const handleCloseShareEIDDialog = () => {
        setOpenShareIDDialog(false)
    }

    return(
        <>
            <Box display="flex" flexDirection={"column"} sx={{justifyContent: 'center', alignItems: 'center'}}>
                <Swiper
                    effect={'flip'}
                    grabCursor={true}
                    modules={[EffectFlip]}
                    className="mySwiper"
                    style={{width: '100%', maxWidth: 640, height: '100%', borderRadius: 15}}
                >
                    <SwiperSlide>
                        <EIDComponent details={details} eIDQRCode={eIDQRCode} />
                    </SwiperSlide>
                </Swiper>
                <Button 
                    variant="outlined" 
                    startIcon={<QrCodeIcon />}
                    sx={{textTransform: 'capitalize', mt: 3}}
                    onClick={handleOpenShareEIDDialog}
                >
                    Share eID
                </Button>
            </Box>

            {openShareIDDialog && 
                <ShareEIDDialogComponent 
                    open={openShareIDDialog} 
                    handleClose={handleCloseShareEIDDialog} 
                />
            }
        </>
    )
}

export default EIDDetailsComponent